if (!customElements.get('custom-doll-form')) {
  customElements.define('custom-doll-form', class CustomDollForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.form = this.closest('form');
      this.nameInput = this.querySelector('[name="properties[Person or character name]"]');
      this.notesInput = this.querySelector('[name="properties[Customization notes]"]');
      this.frontInput = this.querySelector('[data-doll-file="front"]');
      this.backInput = this.querySelector('[data-doll-file="back"]');
      this.photoConfirm = this.querySelector('[name="properties[Reference photos confirmed]"]');
      this.permissionConfirm = this.querySelector('[name="properties[Photo permission confirmed]"]');
      this.counter = this.querySelector('[data-doll-count]');

      if (!this.form || !this.nameInput || !this.notesInput || !this.frontInput || !this.backInput || !this.photoConfirm || !this.permissionConfirm) return;

      this.allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
      this.maxBytes = 15 * 1024 * 1024;
      this.cacheKey = 'mofabia-custom-doll-' + (this.dataset.productId || 'project');
      window.mofabiaCustomDollDrafts = window.mofabiaCustomDollDrafts || {};
      const saved = window.mofabiaCustomDollDrafts[this.cacheKey];

      if (saved) {
        this.nameInput.value = saved.name || '';
        this.notesInput.value = saved.notes || '';
        this.photoConfirm.checked = Boolean(saved.photos);
        this.permissionConfirm.checked = Boolean(saved.permission);
      }

      this.nameInput.addEventListener('input', () => {
        this.saveDraft();
        this.clearError('name', this.nameInput);
      });

      this.notesInput.addEventListener('input', () => {
        this.updateCounter();
        this.saveDraft();
      });

      [['front', this.frontInput], ['back', this.backInput]].forEach(([key, input]) => {
        input.addEventListener('change', () => {
          this.updateFileState(key, input);
          this.validateFile(key, input, false);
        });
      });

      this.photoConfirm.addEventListener('change', () => {
        this.saveDraft();
        this.clearError('photos', this.photoConfirm);
      });

      this.permissionConfirm.addEventListener('change', () => {
        this.saveDraft();
        this.clearError('permission', this.permissionConfirm);
      });

      this.form.addEventListener('submit', (event) => {
        if (!this.validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);

      this.updateCounter();
    }

    updateCounter() {
      if (this.counter) this.counter.textContent = String(this.notesInput.value.length);
    }

    saveDraft() {
      window.mofabiaCustomDollDrafts[this.cacheKey] = {
        name: this.nameInput.value,
        notes: this.notesInput.value,
        photos: this.photoConfirm.checked,
        permission: this.permissionConfirm.checked
      };
    }

    updateFileState(key, input) {
      const label = input.closest('.custom-doll-form__upload');
      const filename = this.querySelector('[data-doll-filename="' + key + '"]');
      const file = input.files && input.files[0];
      if (filename) filename.textContent = file ? file.name : (key === 'front' ? 'Choose front photo' : 'Choose back photo');
      if (label) label.classList.toggle('is-selected', Boolean(file));
    }

    clearError(key, input) {
      input.removeAttribute('aria-invalid');
      const error = this.querySelector('[data-doll-error="' + key + '"]');
      const label = input.closest('.custom-doll-form__upload');
      if (error) error.textContent = '';
      if (label) label.classList.remove('is-invalid');
    }

    setError(key, input, message) {
      input.setAttribute('aria-invalid', 'true');
      const error = this.querySelector('[data-doll-error="' + key + '"]');
      const label = input.closest('.custom-doll-form__upload');
      if (error) error.textContent = message;
      if (label) label.classList.add('is-invalid');
    }

    validateFile(key, input, required) {
      this.clearError(key, input);
      const file = input.files && input.files[0];

      if (!file) {
        if (required) this.setError(key, input, key === 'front' ? 'Upload one clear front full-body photo.' : 'Upload one clear back full-body photo.');
        return !required;
      }

      if (!this.allowedTypes.includes(file.type)) {
        this.setError(key, input, 'Choose a JPG, PNG or WebP image.');
        input.value = '';
        this.updateFileState(key, input);
        return false;
      }

      if (file.size > this.maxBytes) {
        this.setError(key, input, 'Choose an image smaller than 15 MB.');
        input.value = '';
        this.updateFileState(key, input);
        return false;
      }

      return true;
    }

    validate() {
      let valid = true;
      this.clearError('name', this.nameInput);
      this.clearError('photos', this.photoConfirm);
      this.clearError('permission', this.permissionConfirm);

      if (!this.nameInput.value.trim()) {
        this.setError('name', this.nameInput, 'Enter the person or character name.');
        valid = false;
      }

      if (!this.validateFile('front', this.frontInput, true)) valid = false;
      if (!this.validateFile('back', this.backInput, true)) valid = false;

      if (!this.photoConfirm.checked) {
        this.setError('photos', this.photoConfirm, 'Confirm that both photos show the same subject.');
        valid = false;
      }

      if (!this.permissionConfirm.checked) {
        this.setError('permission', this.permissionConfirm, 'Confirm that you have permission to use the photos.');
        valid = false;
      }

      if (!valid) {
        const firstInvalid = this.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus();
      }

      return valid;
    }
  });
}